import { Button, Sidebar, TextArea, UsersBox } from 'components/common';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { Form, Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InterventionUser } from 'features/material/types/interventionTypes';
import { toast } from 'react-toastify';
import { assignIntervention } from 'features/material/services/interventionServices';

interface AffectedUsersInterventionProps {
  id: number;
  affectedUsers: InterventionUser[];
  refetch?: () => void;
  parentRefetch?: () => void;
}

const AffectedusersIntervention: FC<
  SideBarProps<AffectedUsersInterventionProps>
> = ({ sidebar, setSidebarWidth, sidebarWidth, params }) => {
  const { t } = useTranslation();
  const { closeSidebar } = useSidebarManager();
  const [ids, setIds] = useState<string[]>(
    params.affectedUsers.map((user: InterventionUser) => user.id) || [],
  );
  const [allUsersSelected, setAllUsersSelected] = useState(false);

  const handleSubmit = async (values: {
    id: number;
    user_Id?: string;
    step?: string;
    description?: string;
    assign: boolean;
    allUsers: boolean;
    userIds: string[];
  }) => {
    if (values.allUsers) {
      values.userIds = [];
    }
    const res = await assignIntervention(values);
    if (res.success) {
      toast.success(res.message);
      params.refetch?.();
      params.parentRefetch?.();
      closeSidebar(AffectedusersIntervention);
    } else {
      toast.error(res.message);
    }
  };
  return (
    <Sidebar
      size="m"
      type="secondary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <>
        <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-3 minthr-border-b minthr-border-b-3">
          <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
            <img
              className="minthr-icon-m"
              src="/icons/intervention.svg"
              alt=""
            />
          </div>
          <h3>{t('AffectedUsers')}</h3>

          <button
            className="minthr-sidebar-close"
            type="button"
            onClick={() => {
              closeSidebar(AffectedusersIntervention);
            }}
          >
            <img src="/icons/close.svg" alt="" />
          </button>
        </div>
        <Formik
          initialValues={{
            assign: true,
            id: params.id,
            user_id: '',
            allUsers: allUsersSelected,
            description: '',
            userIds: ids,
          }}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ setFieldValue, isSubmitting }) => (
            <Form>
              <div className="minthr-pt-2 minthr-flex minthr-flex-column">
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12">
                    <TextArea
                      className=""
                      name="Description"
                      label={t('Conge.Create.f.Remarque')}
                      rows={3}
                    ></TextArea>
                  </div>
                </div>
              </div>
              <UsersBox
                url={'/api/collaborateur/GetUsersSelect/'}
                ids={ids}
                setIds={(newIds) => {
                  setIds(newIds);
                  setFieldValue('ids', newIds);
                }}
                height={400}
                isBox={false}
                length={10}
                setIsSelectAll={setAllUsersSelected}
              />

              <div className="minthr-sidebar-footer minthr-box-shadow minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-py-4 minthr-mx-n5 minthr-px-6 minthr-mt-auto">
                <button
                  type="button"
                  className="minthr-btn minthr-btn-primary minthr-btn-outline minthr-w-50 minthr-mr-3 minthr-mobile-mr-2 minthr-sidebar-close"
                  onClick={() => {
                    closeSidebar(AffectedusersIntervention);
                  }}
                >
                  {t('cancel')}
                </button>
                <Button
                  type="submit"
                  loading={isSubmitting}
                  className="btn minthr-btn minthr-btn-primary minthr-pl-3 minthr-pr-3 minthr-w-50 save"
                >
                  {t('submit')}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    </Sidebar>
  );
};

export default AffectedusersIntervention;
